const SDK = {
  BASE_URL: "https://minimis.cloud",
  SOCKET_URL: "https://ios.minimis.cloud",
  STRIPE_KEY:
  "pk_live_51Mq48pCHhPy4gmdpHje6ECXZRh9uYTmYFVm6sT3spEPtpwDWDBxDQRLe2dny342Mi3zRms5yHvOvhl9lbYrNb8Xu00np6bOu70",
  // STRIPE_KEY:
    // "pk_test_51Mq48pCHhPy4gmdpAZQj1yYXf95jzpl3KfzkyjlR0ycFQRPB5GkG1TBXhoC0dRJK4IdrvKO2MGp6vtXGCvM3ZObr004SL3pW7o",
  FB_PIXEL_ID: "672056548014780",
  TIK_TOK_PIXEL_ID: "CQOB3TBC77U11VCBB04G",
  X_PIXEL_ID: "qmokf",
  FB_CURRNECY: "USD",
  FB_PRICE: "19",
  mailchimpPriceTag: "gift",
  FB_DISOUNT_PRICE: "0",
  APPLE_PAY_PRICE: 1900,
  APPLE_PAY_CURRENCY: "usd",
  REGION_CONFIG: {
    uk: {
      currency: "gbp",
      price: 1900,
      countryCode: "GB",
      currSymbol: "£",
      text: "",
    },
    eu: {
      currency: "eur",
      price: 1900,
      countryCode: "DE",
      currSymbol: "€",
      text: "",
    },
    us: {
      currency: "usd",
      price: 1900,
      countryCode: "US",
      currSymbol: "$",
      text: " Prices are in USD.",
    },
  },
};

export default SDK;
